import "../App.css";
import React, { useState } from "react";
import PerChangeGraph from "./PerChangeGraph";
import GradeScale from "./GradeScale";
import NavBar from "./NavBar";
import Spinner from "./Spinner";
import Map from "./Map.js";
import FormInput from "./FormInput";
import Footer from "./Footer";
import YourGrade from "./YourGrade";
import Contact from "./Contact";
import ComparisonChart from "./ComparisonChart";

export default function Tool(props) {
  const {
    submitForm,
    updateForm,
    isDisabled,
    perChange,
    spinner,
    formValues,
    grade,
    selectedPosition,
    updateLocation,
    seasonGrades,
  } = props;

  return (
    <div className="ResultsPage">
      <div className="NavBar">
        <NavBar />
      </div>
      <h1 id="ResultsHeader">UbiSMART</h1>
      <h2> Spectral Modeling and Radiation Tool </h2>
      <div className="Results">
        {spinner ? (
          <Spinner spinner={spinner} />
        ) : (
          <>
            {grade ? (
              <>
                <div className="TopHalf">
                  <div className="GradeScaleContainer">
                    <GradeScale grade={grade} formValues={formValues} />
                  </div>
                  <div className="ComparisonChartContainer">
                    <ComparisonChart grade={grade} />
                  </div>
                  <YourGrade
                    formValues={formValues}
                    grade={grade}
                    seasonGrades={seasonGrades}
                  />
                </div>
                <div className="BottomHalf">
                  <PerChangeGraph
                    perChange={perChange}
                    formValues={formValues}
                  />
                </div>
                <Contact />
              </>
            ) : (
              <div className="Bottom-stack">
                <div id="map">
                  <Map
                    formValues={formValues}
                    selectedPosition={selectedPosition}
                    updateLocation={updateLocation}
                  />
                </div>
                <FormInput
                  values={formValues}
                  update={updateForm}
                  submit={submitForm}
                  isDisabled={isDisabled}
                />
              </div>
            )}
          </>
        )}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}
